import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import {
  setProjectsList,
  resetProjectsList,
  restorePersistedState,
  doubleTapRestorePersistedState
} from "../../actions/project-crud-actions";
import {
  resetAppState
} from "../../actions/apptoolbar-actions";
import {
  setCurrentProject
} from "../../actions/project-actions";
import {
  setActiveRegion,
  setActiveLanguage
} from "../../actions/localization-actions";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { processingTypeColoring } from "./project-detail-list-columns";
import "./index.css";
import { Icon } from "office-ui-fabric-react/lib/Icon";
import Project from "../../lib/project";
import { loginUser, logoutUser } from "../../actions/authentication-actions";

import { toggleProjectsCrudModal } from "../../actions/project-crud-actions";
import LoadingScreen from "react-loading-screen";
import SubProjectService from "../../lib/services/sub-project-service";
import { clearViewPort, setCurrentSubProject } from "../../actions/sub-project-actions";
import { getSubProjectStateToPersist, restoreSubProjectPersistedState } from "../../actions/sub-project-crud-actions";
import {
  hideUnsavedChangesDialog,
  loadingBed,
  loadingMultiBedProject,
  setDirtyStateForMultiBeds,
  setSelectedBed
} from "../../actions/multi-bed-actions";
import { chamberBedSetCentralizedCoordinates } from "../../actions/chamber-bed-actions";
import { pipeBedSetCentralizedCoordinates, setPipeDesign } from "../../actions/pipe-bed-actions";
import { resetSystemParams } from "../../actions/system-parameters-actions";
import {
  changeMainManifoldProp,
  clearMainManifoldsState,
  createMainManifold,
  getManifoldMetadata
} from "../../actions/manifold-actions";
import { newBackgroundRequestedClick } from "../../actions/background-actions";
import { backgroundEdit } from "../../actions/drawingtoolbar-actions";

import ScaleService from "../../lib/services/scale-service";
import { scaleUnitValueChange } from "../../actions/drawingtoolbar-actions";
import { emitLineLenght } from "../../actions/measuretool-actions";
import MiniCADAPI_SEARCH from "../../lib/MiniCADAPI_SEARCH";
import ProjectService from "../../lib/services/project-service";

import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressBar } from "primereact/progressbar";

import { Dialog, DialogFooter, DialogType, Dropdown } from "office-ui-fabric-react";
import { InputText } from "primereact/inputtext";
import dayjs from "dayjs";
import GeneralService from "../../lib/services/general-service";
import { setProjectsUrlInvalidDialog } from "../../actions/generic-globals.actions";
import MultiBedService from "../../lib/services/multibed-service";
import {
  updatedSelectedBedValues
} from "../../actions/multi-bed-actions";
import { modalAlertActions } from "../../actions/modal-alert.actions";

class ProjectsCrud extends PureComponent{

  statuses = [];

  constructor( props ) {
    super(props);
    this.state = {
      selectionDetails: "",
      showItemIndexInView: false,
      isCompactMode: false,
      isModalSelection: true,
      hideDialog: true,
      confirmCB: null,
      isLoading: false,
      projects: this.props.projects,
      modalProps: {
        titleAriaId: "myLabelId",
        subtitleAriaId: "mySubTextId",
        isBlocking: false,
        containerClassName: "ms-dialogMainOverride"
      },
      contentProps: {
        type: DialogType.normal,
        title: "Do you want to save the current project?",
        subText: "Your current project state will be saved"
      },
      tableColumns: [],
      selectedProjects: null,
      selectedCount: 0,
      expandedRows: null,

      selectedStatus: null,
      selectedType: null,
      globalFilter: "",
      showLoadingBar: false
    };

    this.collapseAll = this.collapseAll.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.expanderButton = this.expanderButton.bind(this);
    this.formatBOOMFile = this.formatBOOMFile.bind(this);
    this.formatCreatedDate = this.formatCreatedDate.bind(this);
    this.formatEditedDate = this.formatEditedDate.bind(this);
    this.formatProcessingResult = this.formatProcessingResult.bind(this);
    this.formatProcessingStatus = this.formatProcessingStatus.bind(this);
    this.formatSubBOOMFile = this.formatSubBOOMFile.bind(this);
    this.formatCSVFile = this.formatCSVFile.bind(this);
    this.formatStageStorageFileFile = this.formatStageStorageFileFile.bind(this);
    this.formatSubProcessingResult = this.formatSubProcessingResult.bind(this);
    this.onRowSelectDoubleClick = this.onRowSelectDoubleClick.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.reset = this.reset.bind(this);
    this.statusItemTemplate = this.statusItemTemplate.bind(this);
    this.styledHeader = this.styledHeader.bind(this);
    // this.onPageChange = this.onPageChange.bind(this);

    this.statuses = [
      { key: null, text: this.props.content[this.props.lang].allStatuses },
      { key: 'success', text: this.props.content[this.props.lang].successStatus },
      { key: 'failed', text: this.props.content[this.props.lang].failedStatus },
      { key: 'unsubmitted', text: this.props.content[this.props.lang].unsubmitedStatus },
    ];
    this.types = [
      { key: null, text: "All types" },
      { key: "Chamber", text: "Chamber" },
      { key: "Pipe", text: "Pipe" }
    ];
  }

  componentDidMount = () => {
    this.getRecords();
  };

  handleFilterByName = ( e ) => {
    this.setState({
      projects: this.props.projects.filter(project =>
        project.projectName.toLowerCase().includes(e.target.value.toLowerCase()))
    });
  };

  setSelectionDetails = () => {
    setTimeout(() => {
      let selectionCount = 0;
      if (this.state && this.state.selectedProjects) {
        const projects = this.state.selectedProjects;
        selectionCount = projects.length;
        this.setState({ selectedCount: selectionCount });
        if (selectionCount === 1) {
          const msg = `1 ${this.props.content[this.props.lang].itemSelected}:  ${projects[0].projectName}`;
          this.setState({ selectionDetails: msg });
        }
        if (selectionCount > 1) {
          const msg = `${selectionCount} ${this.props.content[this.props.lang].itemsSelected}`;
          this.setState({ selectionDetails: msg });
        }
        if (selectionCount === 0) {
          this.setState({ selectionDetails: "" });
        }
      }
    });
  };

  closeDialog = () => {
    this.setState({
      hideDialog: true
    });
    this.setState({ selectedProjects: null });
  };

  handleConfirm = () => {
    this.state.confirmCB();
  };

  async getSingleRecord( cuid ) {
    this.props.newBackgroundRequestedClick(false);
    this.props.backgroundEdit(true);

    this.setState({
      isLoading: true,
      hideDialog: true
    });
    try {
      let project = new Project(cuid);
      await project.fetch(
        this.props.user.id,
        this.props.resourcesTokens.projects.tableToken
      );

      let state = await project
        .fetchState(
          this.props.user.id,
          this.props.resourcesTokens.projects.blobToken
        );

      if (project.region && project.language) {

        this.props.resetSystemParams();

        // If this was created before we changed "United States of America" to "USA", update it here
        if (project.region === "United States of America")
          project.region = "USA";
        const projRegion = this.props.regions.find(r => r.name === project.region);
        this.props.setActiveRegion(projRegion.id);
        const projLang = this.props.languages.find(l => l.name === project.language);
        this.props.setActiveLanguage(projLang.id);
      }

      this.props.setCurrentProject(project);

      this.props.clearMainManifoldsState();

      try {
        // prevents doing double load, by updating userModified
        let modManifolds = [];
        if (state.mainManifolds && state.mainManifolds.manifolds) {
          modManifolds = state.mainManifolds.manifolds
            .map(manifold => {
              manifold._userModified = true;
              return manifold;
            });
        }
        state.mainManifolds["manifolds"] = [...modManifolds];
      } catch (error) {
        console.info(`ProjectsCrud.getSingleRecord(), state.mainManifolds["manifolds"] :: ${error.message}`);
      }

      this.props.restorePersistedState(state);

      const pType = state.globals.projectType;
      setTimeout(() => {
        if (state.globals.projectType === "PIPE") {
          // dirty clone this object
          let secondStatePass = JSON.parse(JSON.stringify(state));
          // the background is the only one not serializable, assign again
          secondStatePass.background = state.background;
          this.props.doubleTapRestorePersistedState(secondStatePass);
        }
        this.props.toggleProjectsCrudModal(false);

        if (this.props.chamberType && this.props.chamberType.id === 'R-330XLHD') {
          this.props.modalAlertActions({
            text: this.props.content[this.props.lang].warning330XLHD,
            toggle: true,
            btnText: this.props.content[this.props.lang].ok,
          });
        }

        if (this.props.chamberType && this.props.chamberType.id === 'R-180HD') {
          this.props.modalAlertActions({
            text: this.props.content[this.props.lang].warning180HD,
            toggle: true,
            btnText: this.props.content[this.props.lang].ok,
          });
        }
        this.setState({
          isLoading: false
        });
      }, 0);

      // Process multibed load, should load last bed on array
      if (project && project.isMultiBedProject) {

        this.props.loadingBed(true);
        this.props.loadingMultiBedProject(true);

        let beds = [];
        if (state["multiBed"] && state["multiBed"].beds)
          beds = state["multiBed"].beds;
        let lastId = 0;
        if (beds.length > 0)
          lastId = beds[beds.length - 1].id;

        SubProjectService
          .clearViewPortForMultiBed(this.props)
          .then(() => {
            SubProjectService
              .loadSubProject(lastId, this.props)
              .finally(async () => {
                this.props.setDirtyStateForMultiBeds(false);
                this.props.loadingBed(false);
                this.props.loadingMultiBedProject(false);
                if (pType === "PIPE") {
                  await MultiBedService.syncBedsData(beds, this.props);
                }
              });
          });
        this.props.setSelectedBed(lastId);
        this.props.hideUnsavedChangesDialog();
      }
      setTimeout(() => {
        ScaleService.setScale(this.props);
      }, 1000);

    } catch (error) {
      this.setState({
        isLoading: false
      });
      console.error(`ProjectsCrud.getSingleRecord() :: ${error.message}`);
    }
  }

  async deleteAllRecord() {
    this.setState({
      isLoading: true
    });
    this.state.selectedProjects
      .map(async record => {
        try {

          if (!record.country) {
            record.country = this.props.region.name;
          }

          if (!record.region) {
            record.region = this.props.region.id;
          }

          if (!record.language) {
            record.language = "to_delete";
          }

          let project_instance = ProjectService.getNewProjectInstance(record);

          project_instance.active = false;
          await project_instance.persist(
            this.props.user.id,
            this.props.resourcesTokens.projects.tableToken
          );

          await MiniCADAPI_SEARCH.deleteProjectDocument({ project: project_instance });

          setTimeout(async () => {
            await this.getRecords();
          }, 2000);

          if (this.props.project && this.props.project.id === project_instance.id) {
            this.props.resetAppState();
          }
        } catch (e) {
          console.log(`ProjectsCrud.deleteAllRecord() ${e.message}`);
        }
      });

    this.setState({
      isLoading: false
    });
    this.closeDialog();
  }

  async getRecords() {
    let { content, lang } = this.props;
    let tempColumns = [];
    this.setState({
      isLoading: true,
      tableColumns: tempColumns
    });
    let projects = [], projectsCount = 0;
    try {

      const config = {
        PartitionKey: this.props.user.id,
        orderBy: { createdDate: "desc" },
        top: 100,
        skip: 0
      };

      let restoredProjects, restoredCount;
      try {
        restoredProjects = JSON.parse(sessionStorage.getItem("projects"));
        restoredCount = JSON.parse(sessionStorage.getItem("projectsCount"));
      } catch (e) {
        console.info("null error corrected");
      }

      if (restoredProjects) {

        projects = restoredProjects;
        projectsCount = restoredCount;
        this.setState({ showLoadingBar: true });
        MiniCADAPI_SEARCH.getSearchProjects(config)
          .then(async rsp => {
            projects = rsp.value;
            projectsCount = rsp["@odata.count"];

            projectsCount = projectsCount - 100;
            const runFor = Math.round(projectsCount / 100);
            let counter = 0;

            for (let i = 0; i < runFor; i++) {
              counter = counter + 100;
              const srp = await MiniCADAPI_SEARCH.getSearchProjects({
                PartitionKey: this.props.user.id,
                orderBy: { createdDate: "desc" },
                top: 100,
                skip: counter
              });
              projects = [...projects, ...srp.value];
            }

            const subProjects = await SubProjectService.loadAllUserSubProjects(
              this.props.user.id,
              this.props.resourcesTokens.subprojects.tableToken,
              this.props
            );

            // Stitch subprojects to projects
            for (const proj of projects) {
              let projectSubProjects = [];
              proj["id"] = proj.RowKey;
              proj["subProjects"] = [];
              proj["multiBeds"] = "";

              if (proj.processingStatus === "failedDownload"){
                // required to fix rare instance where the value is failedDownload
                proj.processingStatus = "failed"
              }

              if (proj.isMultiBedProject || proj.ismultibedProject) {
                projectSubProjects = subProjects.filter(( subProjects ) => {
                  return subProjects.parentProjectId === proj.id;
                });
                if (projectSubProjects && projectSubProjects.length > 0 && proj.id === projectSubProjects[0].parentProjectId) {
                  proj["subProjects"] = projectSubProjects;
                }
              }
            }

            projects.forEach(proj => {
              proj.translatedProjectType = content[lang][proj.projectType.toLowerCase()];
            });

            this.props.setProjectsList(projects);

            this.setState({
              projects: this.props.projects
            });
            this.setState({ showLoadingBar: false });

          });
      } else {

        this.setState({ showLoadingBar: true });
        let { value, "@odata.count": count } = await MiniCADAPI_SEARCH.getSearchProjects(config);
        projects = value;
        projectsCount = count;

        const objJSONpr = JSON.stringify(value);
        const objJSONct = JSON.stringify(count);
        sessionStorage.setItem("projects", objJSONpr);
        sessionStorage.setItem("projectsCount", objJSONct);

        projectsCount = projectsCount - 100;
        const runFor = Math.round(projectsCount / 100);
        let counter = 0;

        for (let i = 0; i < runFor; i++) {
          counter = counter + 100;
          const srp = await MiniCADAPI_SEARCH.getSearchProjects({
            PartitionKey: this.props.user.id,
            orderBy: { createdDate: "desc" },
            top: 100,
            skip: counter
          });
          projects = [...projects, ...srp.value];
        }

        const subProjects = await SubProjectService.loadAllUserSubProjects(
          this.props.user.id,
          this.props.resourcesTokens.subprojects.tableToken,
          this.props
        );

        // Stitch subprojects to projects
        for (const proj of projects) {
          let projectSubProjects = [];
          proj["id"] = proj.RowKey;
          proj["subProjects"] = [];
          proj["multiBeds"] = "";

          if (proj.processingStatus === "failedDownload"){
            // required to fix rare instance where the value is failedDownload
            proj.processingStatus = "failed"
          }

          if (proj.isMultiBedProject || proj.ismultibedProject) {
            projectSubProjects = subProjects.filter(( subProjects ) => {
              return subProjects.parentProjectId === proj.id;
            });
            if (projectSubProjects && projectSubProjects.length > 0 && proj.id === projectSubProjects[0].parentProjectId) {
              proj["subProjects"] = projectSubProjects;
            }
          }
        }

        this.props.setProjectsList(projects);

        projects.forEach(proj => {
          proj.translatedProjectType = content[lang][proj.projectType.toLowerCase()];
        });
        this.setState({
          projects: this.props.projects
        });
        this.setState({ showLoadingBar: false });
        console.info("Projects ADDED!");
      }
    } catch (e) {
      console.error(`Error fetching project(s) ${e.message}`);
    }

    this.setState({
      isLoading: false
    });
  }

  onRowSelectDoubleClick( event ) {
    const { data: item } = event;
    this.setState({
      confirmCB: () => {
        this.getSingleRecord(item.id);
      },
      contentProps: {
        type: DialogType.normal,
        title: this.props.content[this.props.lang].loadMyProjectDialogMain.replace("{0}", item.projectName),
        subText: this.props.content[this.props.lang].loadProjectDialogSub
      },
      hideDialog: false
    });
  }

  styledHeader( data ) {
    return <span style={{
      display: "flex",
      alignItems: "flex-end",
      marginRight: "5px"
    }}><i className={`ms-Icon ms-Icon--${data.iconName}`} style={{ fontSize: "13px", marginRight: "5px" }} /> {data.fieldName}</span>;
  }

  expandAll() {
    let expandedRows = {};
    this.state.projects.forEach(p => expandedRows[`${p.id}`] = true);
    this.setState({
      expandedRows
    });
  }

  expandById( id, eve ) {
    let expandedRows = { ...this.state.expandedRows };
    if (expandedRows && expandedRows[id]) {
      delete expandedRows[id];
    } else {
      expandedRows[id] = true;
    }
    this.setState({
      expandedRows
    });
  }

  collapseAll() {
    let expandedRows = {};
    this.state.projects.forEach(p => expandedRows[`${p.id}`] = false);
    this.setState({
      expandedRows
    });
  }

  formatProcessingStatus( project ) {
    const { processingStatus } = project;
    return <span
      className={`status ${processingTypeColoring[processingStatus]}`}>{this.props.content[this.props.lang][processingStatus]}</span>;
  }

  formatBOOMFile( project ) {
    const { processingStatus: status, bomFileUrl, bomFileUrlPipe, isMultiBedProject } = project;

    const validURL = GeneralService.isAzureUrlValid(
      bomFileUrl ? bomFileUrl : bomFileUrlPipe
    );

    const isInternalUser = true;

    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      if (!isMultiBedProject) {
        // console.log(`bomFileUrl ${bomFileUrl}`);
        return <ul>
          {bomFileUrl ?
            validURL ?
              <li><a href={bomFileUrl}>{this.props.content[this.props.lang].downloadChamberBom}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadChamberBom}</a></li>
            : <span />}
          {bomFileUrlPipe ?
            validURL ?
              <li><a href={bomFileUrlPipe}>{this.props.content[this.props.lang].downloadPipeBom}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadPipeBom}</a></li>
            : <span />}
        </ul>;
      }
      /* We dont show link on multibed*/
      else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  }

  formatCSVFile( project ) {
    const { processingStatus: status, csvFileUrl, csvFileUrlPipe, isMultiBedProject } = project;
    const validURL = GeneralService.isAzureUrlValid(
      csvFileUrl ? csvFileUrl : csvFileUrlPipe
    );
    const isInternalUser = this.props.user.mail.includes("@ads-pipe")
      || this.props.user.mail.includes("@rand.com")
      || this.props.user.mail.includes("@adspipe.com")
      || process.env.NODE_ENV === "development";
    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      if (!isMultiBedProject) {
        return <ul>
          {csvFileUrl ?
            validURL ?
              <li><a href={csvFileUrl}>{this.props.content[this.props.lang].downloadChamberCsv}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadChamberCsv}</a></li>
            : <span />}
          {csvFileUrlPipe ?
            validURL  ? <span />: <span />
            /* To Activate when Pipes receive CSV
            <li><a href={csvFileUrlPipe}>{this.props.content[this.props.lang].downloadPipeCsv}</a></li> :
            <li><a href="#" onClick={() => {
              this.props.setProjectsUrlInvalidDialog(true);
            }}>{this.props.content[this.props.lang].downloadPipeCsv}</a></li>*/
            : <span />}
        </ul>;
      } else {
        return "N/A"; /* We dont show link on multibed, it is by design*/
      }
    } else {
      return "N/A";
    }
  }

  formatStageStorageFileFile( project ) {
    const { processingStatus: status, stageStorageURL, isMultiBedProject, singleBedStageStorageURL } = project;
    const validURL = GeneralService.isAzureUrlValid( stageStorageURL);
    const isInternalUser = true; // Requested on Monday: https://imaginit.monday.com/boards/232436054/pulses/4297061164
    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      if (!isMultiBedProject) {
        return <ul>
          {stageStorageURL ?
            validURL ?
              <li><a href={singleBedStageStorageURL}>{this.props.content[this.props.lang].downloadStageStorageXlsx}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadStageStorageXlsx}</a></li>
            :  <span/>}
        </ul>;
      } else {
        return "N/A"; /* We dont show link on multibed, it is by design*/
      }
    } else {
      return "N/A";
    }
  }

  /**
   * Future use to show urls on children
   * @param project
   * @returns {JSX.Element|string}
   */
  formatSubBOOMFile( project ) {
    const { processingStatus: status, bomFileUrlPipe, subProjects } = project;

    const isInternalUser = this.props.user.mail.includes("@ads-pipe")
      || this.props.user.mail.includes("@rand.com")
      || this.props.user.mail.includes("@adspipe.com")
      || process.env.NODE_ENV === "development";

    if (status === Project.PROCESSING_STATUS.success && isInternalUser) {
      const subProject = subProjects.find(subProject => {
        return subProject.parentProjectId === project.id;
      });

      const validURL = GeneralService.isAzureUrlValid(
        subProject.bomFileUrl ? subProject.bomFileUrl : subProject.bomFileUrlPipe
      );

      if (subProject.parentProjectId) {
        return <ul>
          {subProject.bomFileUrl ?
            <li><a href={"%"}> TEXT</a></li>
            : <span />}
          {subProject.bomFileUrlPipe ?
            validURL ?
              <li><a href={bomFileUrlPipe}>{this.props.content[this.props.lang].downloadPipeBom} ... </a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadPipeBom}</a></li>
            : <span />}
        </ul>;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  }

  formatProcessingResult( project ) {
    const { processingStatus: status, outputFileURL, outputFileURLPipe, projectType, isMultiBedProject } = project;

    const validURL = GeneralService.isAzureUrlValid(
      outputFileURL ? outputFileURL : outputFileURLPipe
    );

    if (status === Project.PROCESSING_STATUS.success) {
      if (!isMultiBedProject) {
        return <ul>
          {outputFileURL ?
            validURL ?
              <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadChamberResults}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadChamberResults}</a></li>
            : <span />}
          {outputFileURLPipe ?
            validURL ?
              <li><a href={outputFileURLPipe}>{this.props.content[this.props.lang].downloadPipeResults}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadPipeResults}</a></li>
            : <span />}
        </ul>;

      } else if (isMultiBedProject && projectType !== "PIPE") {

        return <ul>
          {outputFileURL ?
            validURL ?
              <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadChamberResults}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadChamberResults}</a></li>
            : <span />}
          {outputFileURLPipe ?
            validURL ?
              <li><a href={outputFileURLPipe}>{this.props.content[this.props.lang].downloadPipeResults}</a></li> :
              <li><a href="#" onClick={() => {
                this.props.setProjectsUrlInvalidDialog(true);
              }}>{this.props.content[this.props.lang].downloadPipeResults}</a></li>
            : <span />}
        </ul>;

      } else {
        return "N/A";
      }


    } else {
      return "N/A";
    }
  }

  /**
   * Future use to show urls on children
   * @param project
   * @returns {JSX.Element|string}
   */
  formatSubProcessingResult( project ) {
    const { processingStatus: status, outputFileURL, outputFileURLPipe, projectType, isMultiBedProject, parentProjectId } = project;
    if (status === Project.PROCESSING_STATUS.success) {
      if (!isMultiBedProject) {
        return <ul>
          {outputFileURL ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadChamberResults}</a></li>
            : <span />}
          {outputFileURLPipe ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadPipeResults}</a></li>
            : <span />}
        </ul>;

      } else if (isMultiBedProject && projectType !== "PIPE") {

        return <ul>
          {outputFileURL ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadChamberResults}</a></li>
            : <span />}
          {outputFileURLPipe ?
            <li><a href={outputFileURL}>{this.props.content[this.props.lang].downloadPipeResults}</a></li>
            : <span />}
        </ul>;

      } else {
        return "N/A";
      }


    } else {
      return "N/A";
    }
  }

  formatCreatedDate( project ) {
    const { createdDate } = project;
    return <span>{dayjs(createdDate).format("MM-DD-YYYY-hh:mm:ss-A")}</span>;
  }

  formatEditedDate( project ) {
    const { editedDate } = project;
    if (editedDate) {
      return <span>{dayjs(editedDate).format("MM-DD-YYYY-hh:mm:ss-A")}</span>;
    } else {
      return this.props.content[this.props.lang].notEdited;
    }
  }

  expanderButton( project ) {
    if (project && project.subProjects.length > 0) {
      let icon = "pi  pi-angle-right";
      if (this.state && this.state.expandedRows && this.state.expandedRows[project.id]) icon = "pi  pi-angle-down";
      // This fixes a rendering bug on the desktop
      return window._bridge !== undefined
        ? <Button icon={icon}
                  className="p-button-rounded p-button-text icon-expander icon-expander-patch"
                  onClick={this.expandById.bind(this, project.id)} />
        : <Button icon={icon}
                  className="p-button-rounded p-button-text icon-expander"
                  onClick={this.expandById.bind(this, project.id)} />;
    }
    return false;
  }

  onStatusChange( event, option ) {
    this.dt.filter(option.key, "processingStatus", "equals");
    this.setState({ selectedStatus: option.key });
  }

  onTypeChange( event, option ) {
    this.dt.filter(option.key, "translatedProjectType", "equals");
    this.setState({ selectedType: option.key });
  }

  statusItemTemplate( option ) {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  }

  reset() {
    this.setState({
      selectedStatus: null,
      selectedType: null,
      globalFilter: ""
    });
    this.dt.reset();
  }

  onPageChangeEvent( event ) {
    console.log("change!!!", event);
  }

  render() {
    const {
      lang,
      content
    } = this.props;
    const promptDelete = () => {
      const projects = this.state.selectedProjects.map(project => project.projectName).join(", ");
      this.setState({
        confirmCB: () => this.deleteAllRecord(),
        contentProps: {
          type: DialogType.normal,
          title: content[lang].confirmProjectsDeletion,
          subText: `${content[lang].theProjects} ${projects} ${content[lang].willBeDeleted}`
        },
        hideDialog: false
      });
    };
    const bomFileText = content[lang].bomFile;
    const csvFileText = content[lang].csvFile;
    const stageStorageFileText = content[lang].stageStorageFile;
    const resultText = content[lang].results;
    const pipeResultsText = content[lang].downloadPipeResults;
    const pipeBomText = content[lang].downloadPipeBom;
    const pipeCsvText = content[lang].downloadPipeCsv;

    const styledHeader = ( data ) => {
      return <span style={{
        display: "flex",
        alignItems: "flex-end",
        marginRight: "5px"
      }}><i className={`ms-Icon ms-Icon--${data.iconName}`}
            style={{ fontSize: "13px", marginRight: "5px" }} /> {data.fieldName}</span>;
    };

    const resultBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.outputFileURL);
      const text = pipeResultsText;
      return data.outputFileURL && data.outputFileURL.length ?
        validURL ?
          ( <a href={data.outputFileURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const bomBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.bomFileUrl);
      const text = data.projectType === "CHAMBER" ? bomFileText : pipeBomText;
      return data.bomFileUrl && data.bomFileUrl.length ?
        validURL ?
          ( <a href={data.bomFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const csvBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.csvFileUrl);
      const text = data.projectType === "CHAMBER" ? csvFileText : pipeCsvText;
      return data.csvFileUrl && data.csvFileUrl.length ?
        validURL ?
          ( <a href={data.csvFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const stageStorageBodyTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.stageStorageURL);
      const text =  stageStorageFileText;
      return data.stageStorageURL && data.stageStorageURL.length ?
        validURL ?
          ( <a href={data.stageStorageURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const csvBodyChamberTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.csvFileUrl);
      const text = data.projectType === "CHAMBER" ? csvFileText : pipeCsvText;
      return data.csvFileUrl && data.csvFileUrl.length ?
        validURL ?
          ( <a href={data.csvFileUrl}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const stageStorageBodyChamberTempl = ( data ) => {
      const validURL = GeneralService.isAzureUrlValid(data.multiBedStageStorageURL);
      const text = stageStorageFileText;
      return data.multiBedStageStorageURL && data.multiBedStageStorageURL.length ?
        validURL ?
          ( <a href={data.multiBedStageStorageURL}>{text}</a> ) :
          <li><a href="#" onClick={() => {
            this.props.setProjectsUrlInvalidDialog(true);
          }}>{text}</a></li>
        : "N/A";
    };

    const rowExpansionTemplate = data => {
      return (
        ( data.subProjects.length > 0 ) ?
          data.projectType === "PIPE"
            ? <div className="expanded-subprojects">
              {/* Dataset for Multibed - Subprojects */}
              <DataTable value={data.subProjects} className={"expanded-projects"}>
                <Column field="projectName"
                        header={styledHeader({ iconName: "CRMReport", fieldName: "" })}
                        style={{
                          width: "400px"
                        }}
                />
                <Column field="bomFileURLPipe"
                        columnKey="bomFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: bomFileText })}
                        body={bomBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
                {/*<Column field="csvFileURLPipe"
                        columnKey="csvFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: csvFileText })}
                        body={csvBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="outputFileURLPipe"
                        columnKey="outputFileURLPipe"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: resultText })}
                        body={resultBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
              </DataTable>
            </div>
            : <div className="expanded-subprojects">
              {/* Dataset for Multibed - Subprojects */}
              <DataTable value={data.subProjects} className={"expanded-projects"}>
                <Column field="projectName"
                        header={styledHeader({ iconName: "CRMReport", fieldName: "" })}
                        style={{
                          width: "400px"
                        }}
                />
                {/*<Column field="stageStorageURL"
                        columnKey="stageStorageURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: stageStorageFileText })}
                        body={stageStorageBodyChamberTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="bomFileURL"
                        columnKey="bomFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: bomFileText })}
                        body={bomBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
                {/*<Column field="csvFileURL"
                        columnKey="csvFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: csvFileText })}
                        body={csvBodyChamberTempl}
                        style={{
                          width: "300px"
                        }}
                />*/}
                <Column field="outputFileURL"
                        columnKey="outputFileURL"
                        header={styledHeader({ iconName: "ZipFolder", fieldName: resultText })}
                        body={resultBodyTempl}
                        style={{
                          width: "300px"
                        }}
                />
              </DataTable>
            </div>



          /*: <div className="expanded-subprojects">
            {/!* Dataset for Multibed - Subprojects *!/}
            <DataTable value={data.subProjects} className={"expanded-projects"}>
              <Column field="projectName" />
            </DataTable>
          </div>*/
          : null
      );
    };

    const statusFilter = <Dropdown
      placeholder="Select a Status"
      styles={
        {
          dropdownItemSelected: {
            color: "white",
            backgroundColor: "#0C92CD",
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          dropdownItem: {
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          width: "100px"
        }
      }
      readOnly={false}
      onChange={this.onStatusChange}
      selectedKey={this.state.selectedStatus ? this.state.selectedStatus : null}
      options={this.statuses} />;

    const typeFilter = <Dropdown
      placeholder="Select a Type"
      styles={
        {
          dropdownItemSelected: {
            color: "white",
            backgroundColor: "#0C92CD",
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          dropdownItem: {
            selectors: {
              "&:hover": {
                color: "white"
              }
            }
          },
          width: "100px"
        }
      }
      readOnly={false}
      onChange={this.onTypeChange}
      selectedKey={this.state.selectedType ? this.state.selectedType : null}
      options={this.types} />;

    return (
      <div id="ProjectsCrud" style={{ width: '100%' }}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row title-row">
            <div className="ms-Grid-col ms-sm12 ms-md10 ms-lg6">
              <p className="ms-fontSize-xl crud-title ms-fontColor-white ms-normalize">
                <Icon iconName="DocumentSet" className="ms-IconExample" /> {content[lang].manageProjects}
              </p>
            </div>
          </div>
        </div>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row ms-bgColor-neutralLight" style={{ height: '65px' }}>
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 input-container">
              <InputText
                type="search"
                value={this.state.globalFilter}
                onChange={(e) => this.setState({ globalFilter: e.target.value })}
                placeholder={content[lang].globalSearch}
                className={'global-search-1'}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              {(() => {
                if (this.state.selectedCount > 0) {
                  return (
                    <DefaultButton
                      disabled={false}
                      onClick={promptDelete}
                      allowDisabledFocus={true}
                      className={'delete-button'}
                      text={content[lang].deleteSelected}
                      data-automation-id="delete-selected"
                    />
                  );
                }
              })()}
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              {(() => {
                if (
                  this.state.selectedCount === 1 &&
                  this.state.selectedProjects &&
                  this.state.selectedProjects.length > 0 &&
                  this.state.selectedProjects[0]
                ) {
                  return (
                    <PrimaryButton
                      disabled={false}
                      className="load-selected"
                      allowDisabledFocus={true}
                      data-automation-id="load-selected"
                      text={`${content[lang].load} '${this.state.selectedProjects[0].projectName}'`}
                      onClick={() => this.getSingleRecord(this.state.selectedProjects[0].id)}
                    />
                  );
                }
              })()}
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              <p className={'selection-details'}>
                <b>{this.state.selectionDetails}</b>
              </p>
            </div>
          </div>
        </div>

        {/*DETAIL LIST DataTable for main projects*/}
        {this.state.showLoadingBar ? <ProgressBar mode="indeterminate" /> : null}
        <DataTable
          ref={(el) => (this.dt = el)}
          globalFilter={this.state.globalFilter}
          emptyMessage={content[lang].noProjectsFound}
          value={this.state.projects}
          selection={this.state.selectedProjects}
          onSelectionChange={(evt) => {
            this.setState({ selectedProjects: evt.value });
            this.setSelectionDetails();
          }}
          onRowDoubleClick={this.onRowSelectDoubleClick}
          paginator
          rows={10}
          currentPageReportTemplate={`{first} / {last} ${content[lang].of} {totalRecords}`}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          rowsPerPageOptions={[10, 25, 50]}
          expandedRows={this.state.expandedRows}
          onRowToggle={(evt) => this.setState({ expandedRows: evt.data })}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey="id"
          scrollable
          scrollDirection="horizontal"
          style={{ width: '100%', overflowX: 'auto !important' }}
          scrollHeight="60vh"
          rowHover>
          <Column selectionMode="multiple" headerStyle={{ width: '3em' }} className={'forced-padding'} />
          <Column expander style={{ width: '3em' }} body={this.expanderButton} />
          <Column
            field="projectName"
            columnKey="projectName"
            header={this.styledHeader({
              iconName: 'CRMReport',
              fieldName: content[lang]['projectName'].replace(':', ''),
            })}
            headerStyle={{
              width: '200px',
            }}
            sortable
            filter
            filterMatchMode="contains"
            filterPlaceholder={content[lang].byName}
          />
          <Column
            field="city"
            header={this.styledHeader({ iconName: 'POI', fieldName: content[lang].city })}
            headerStyle={{
              width: '200px',
            }}
            sortable
            filter
            filterMatchMode="contains"
            filterPlaceholder={content[lang].byCity}
          />
          <Column
            field="state"
            header={this.styledHeader({ iconName: 'POISolid', fieldName: content[lang].state })}
            headerStyle={{
              width: '200px',
            }}
            sortable
            filter
            filterPlaceholder={content[lang].byState}
          />
          {/*<Column field="translatedProjectType"
                  columnKey="translatedProjectType"
                  header={this.styledHeader({
                    iconName: "BulletedList2",
                    fieldName: content[lang].productType.replace(":", "")
                  })}
                  headerStyle={{
                    width: "200px"
                  }}
                  sortable
                  filter
                  filterPlaceholder="by type"
                  filterElement={typeFilter}
          />*/}
          <Column
            field="processingStatus"
            columnKey="processingStatus"
            header={this.styledHeader({ iconName: 'WorkItem', fieldName: content[lang].processingStatus })}
            body={this.formatProcessingStatus}
            headerStyle={{
              width: '200px',
            }}
            sortable
            filter
            filterPlaceholder="by status"
            filterElement={statusFilter}
          />
          <Column
            field="columnResult"
            columnKey="columnResult"
            header={this.styledHeader({ iconName: 'ZipFolder', fieldName: content[lang].result })}
            body={this.formatProcessingResult}
            headerStyle={{
              width: '300px',
            }}
            //sortable
          />
          <Column
            field="columnStageStorageFileUrl"
            header={this.styledHeader({ iconName: 'ZipFolder', fieldName: content[lang].stageStorageFile })}
            body={this.formatStageStorageFileFile}
            headerStyle={{
              width: '300px',
            }}
          />
          {/*<Column field="columnBomFileUrl"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].bomFile })}
                  body={this.formatBOOMFile}
                  headerStyle={{
                    width: "300px"
                  }}
          />*/}
          {/*<Column field="columnCsvFileUrl"
                  header={this.styledHeader({ iconName: "ZipFolder", fieldName: content[lang].csvFile })}
                  body={this.formatCSVFile}
                  headerStyle={{
                    width: "300px"
                  }}
          />*/}
          <Column
            field="createdDate"
            columnKey="createdDate"
            header={this.styledHeader({ iconName: 'Calendar', fieldName: content[lang].editedDate })}
            body={this.formatEditedDate}
            headerStyle={{
              width: '200px',
            }}
            sortable
          />
          <Column
            field="editedDate"
            columnKey="editedDate"
            header={this.styledHeader({ iconName: 'Calendar', fieldName: content[lang].createdDate })}
            body={this.formatCreatedDate}
            headerStyle={{
              width: '200px',
            }}
            sortable
          />
        </DataTable>
        {this.state.showLoadingBar ? <ProgressBar mode="indeterminate" /> : null}
        <Dialog
          onDismiss={this.closeDialog}
          hidden={this.state.hideDialog}
          modalProps={this.state.modalProps}
          dialogContentProps={this.state.contentProps}>
          <DialogFooter>
            <PrimaryButton onClick={() => this.handleConfirm()} text={content[lang].confirm} />
            <DefaultButton
              onClick={() => this.closeDialog()}
              text={content[lang].cancel}
              className={'outline_grey_ads'}
            />
          </DialogFooter>
        </Dialog>
        <LoadingScreen
          text={'Loading'}
          textColor={'#0C92CD'}
          spinnerColor={'#0C92CD'}
          className="loadingScreen"
          loading={this.state.isLoading}
          bgColor={'rgba(50, 50, 50, 0.2)'}>
          <div
            className="loadingDiv"
            style={{
              visibility: !this.props.chamberType && this.state.errorDialogHidden ? 'visible' : 'hidden',
            }}
          />
        </LoadingScreen>
      </div>
    );
  }
}

const mapStateToProps = state => {
  let scaleData = {};

  if (
    state.project &&
    state.project.project &&
    state.project.project.projectType
  ) {

    scaleData["projectType"] = state.project.project.projectType;

    scaleData["scaleValue"] = ( state.project.project.projectType === "CHAMBER" )
      ? state.globals.scaleValue
      : state.pipeGlobals.scaleValue;

    scaleData["scalePixels"] = ( state.project.project.projectType === "CHAMBER" )
      ? state.globals.scalePixels
      : state.pipeGlobals.scalePixels;

  } else {
    scaleData = {};
  }

  return {
    lang: state.localization.lang,
    project: state.project.project,
    user: state.authentication.user,
    content: state.localization.content,
    projects: state.projectsCrud.projects,
    projectInfo: state.project.projectInfo,
    resourcesTokens: state.authentication.resourcesTokens,
    regions: state.localization.regions,
    region: state.localization.region,
    languages: state.localization.languages,
    chamberbed: state.chamberbed,
    manifolds: state.mainManifolds.manifolds,

    computeWidth: state.viewport.computeWidth,
    computedHeight: state.viewport.computedHeight,
    bedWidth: state.pipeBed.dimensions.width.px,
    bedLength: state.pipeBed.dimensions.length.px,
    chamberBedHeight: state.chamberbed.height,
    chamberBedWidth: state.chamberbed.width,
    chamberBedScaleX: state.chamberbed.scaleX,
    chamberBedScaleY: state.chamberbed.scaleY,
    scaleData: scaleData,
    chamberType: state.globals.chamberType
  };
};

const mapDispatchToProps = {
  doubleTapRestorePersistedState,
  getManifoldMetadata,
  loginUser,
  logoutUser,
  resetAppState,
  resetProjectsList,
  resetSystemParams,
  restorePersistedState,
  setActiveLanguage,
  setActiveRegion,
  setCurrentProject,
  setProjectsList,
  toggleProjectsCrudModal,
  createMainManifold,
  clearMainManifoldsState,
  clearViewPort,
  restoreSubProjectPersistedState,
  setCurrentSubProject,
  setSelectedBed,
  loadingBed,
  loadingMultiBedProject,
  hideUnsavedChangesDialog,
  chamberBedSetCentralizedCoordinates,
  pipeBedSetCentralizedCoordinates,
  setPipeDesign,
  getSubProjectStateToPersist,

  changeMainManifoldProp,
  setDirtyStateForMultiBeds,
  scaleUnitValueChange,
  emitLineLenght,
  newBackgroundRequestedClick,
  backgroundEdit,
  setProjectsUrlInvalidDialog,
  updatedSelectedBedValues,
  modalAlertActions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsCrud);



// WEBPACK FOOTER //
// ./src/components/ProjectsCrud/index.js